import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Api from "@/services/api"
    import { Segment } from "@/services/types";
    import { ElMessage, FormInstance, FormRules, ElSelectV2 } from "element-plus"
    import { OptionType } from "element-plus/es/components/select-v2/src/select.types";
    import { reactive, ref, computed, watchEffect } from "vue"

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateTravelPrice',
  props: {
    travel_company_id: {},
    segments: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

    const props = __props
    const emit = __emit

    const options = computed<Array<OptionType>>(() => {
        return props.segments.map((value: Segment) => {
            return {value: value.id, label: `${value.from?.name} - ${value.to?.name}`}
        })
    })

    const segment = reactive<{price: number, trip_segment_id: number}>({
        trip_segment_id: 1,
        price: 0
    })

    const rules = reactive<FormRules<{price: number, trip_segment_id: number}>>({
        price: [{required: true, message: 'Preencha este campo'}],
        trip_segment_id: [{required: true, message: 'Preencha este campo'}],
    })

    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true

                const res = await Api.post(`admin/travel-companies/add-segment/${props.travel_company_id}/${segment.trip_segment_id}`, segment)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Carro cadastrado com sucesso'})
                    emit('close')
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }

    watchEffect(() => {
        console.log(segment.trip_segment_id)
    })

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "formRef",
    ref: formRef,
    disabled: saving.value,
    rules: rules,
    model: segment,
    "label-position": "top"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        prop: "trip_segment_id",
        label: "Trecho"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElSelectV2), {
            clearable: false,
            filterable: "",
            loading: saving.value,
            name: "trip_segment_id",
            modelValue: segment.trip_segment_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((segment.trip_segment_id) = $event)),
            options: options.value
          }, null, 8, ["loading", "modelValue", "options"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        prop: "price",
        label: "Preço da viagem"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input_number, {
            step: 0.001,
            min: 0.001,
            name: "price",
            modelValue: segment.price,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((segment.price) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        plain: "",
        loading: saving.value,
        size: "large",
        type: "primary",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (submit(formRef.value)), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" Definir Preço ", -1)
        ]))]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["disabled", "rules", "model"]))
}
}

})